<template>
  <v-dialog hide-overlay max-width="800px" v-model="show">
    <v-card>
      <v-card-title>見積</v-card-title>
      <v-card-actions>
        <v-btn @click="show = false">戻る</v-btn>
      </v-card-actions>
      <v-container fluid>
        <div class="card-text">
          <v-card-text :key="employee.email" v-for="employee in employees">
            <v-text-field
              disabled
              label="氏名"
              v-model="employee.username"
            ></v-text-field>
            <v-text-field
              disabled
              label="email"
              v-model="employee.email"
            ></v-text-field>
          </v-card-text>
        </div>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['employees'],
  data() {
    return { selecetd: '', show: false }
  },
  methods: {
    close() {
      this.$emit('closeEvent', false)
    },
    popup() {
      this.show = true
    },
  },
}
</script>

<style>
.select-area {
  border: 2px solid #000;
  height: 300px;
}

.card-text {
  padding: 0px 10px;
}
</style>
